module.exports = __webpack_public_path__ + "static/media/bus.4445f217.svg";